import qs from "qs";
import {apiVoissa} from "../../libs/api";


export const fetchMembers = (query = {}, config = {}) => {
    return apiVoissa.get(`/members?${qs.stringify(query)}`, config)
};

// Nombre de membres actuellement en ligne. `limit: 1` : on ne veut que le total, pas la liste —
// le serveur renvoie `total` avec son propre cache, la réponse reste légère.
export const fetchOnlineMembersCount = async (config = {}) => {
    const { data } = await apiVoissa.get(`/members?${qs.stringify({ connected: 1, limit: 1 })}`, config);
    return typeof data?.total === 'number' ? data.total : null;
};

export const MEMBERS_KEY = `MEMBERS`;
export const MEMBERS_ONLINE_COUNT_KEY = `MEMBERS_ONLINE_COUNT`;